module.exports = __webpack_public_path__ + "img/vegetable-lambs-quarters-350x184.24a0f185.jpg";